import { createContext, useContext } from 'react';
import { useAuth } from '../../features/auth/hooks/useAuth';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const auth = useAuth();

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthContext() {
  const context = useContext(AuthContext);
  if (!context) {
    // In development mode, hot reload can cause this error temporarily
    if (import.meta.env.DEV) {
      console.warn('useAuthContext called outside AuthProvider (possibly due to hot reload)');
      return {
        user: null,
        isAuthorized: null,
        authMessage: '',
        authToken: null,
        initData: '',
        initDataRaw: ''
      };
    }
    throw new Error('useAuthContext must be used within AuthProvider');
  }
  return context;
}
